module.exports = __webpack_public_path__ + "static/media/lightbulb_5.132c7212.png";